import React from 'react';

import { AxiosError } from 'axios';
import { Modal, Toast } from 'src/common/components';

import { scheduleTestCalls } from '../api';
import { useAccountProfileContext } from '../context';

const BusinessPhonesScheduleTestCallModal: React.FC = () => {
  const { state } = useAccountProfileContext();
  const { account } = state;
  const { id, business_phones: businessPhones } = account;

  const handleScheduledTestCalls = async (): Promise<void> => {
    try {
      await scheduleTestCalls({ account_id: id });
      Toast.success('The test calls was scheduled successfully.');
    } catch (err) {
      const error = err as AxiosError<{ detail: string }>;
      let errorMsg = 'The test calls could not be scheduled at the moment.';
      const detail = error?.response?.data?.detail;
      if (detail === 'call_rescue_tests_scheduled_for_account') {
        errorMsg = 'Account has scheduled test calls already.';
      }
      if (detail === 'call_rescue_tests_disabled_for_account') {
        errorMsg = 'Account has test calls disabled.';
      }
      if (detail === 'account_has_no_business_phone') {
        errorMsg = 'Account has no business phones.';
      }
      Toast.error(errorMsg);
    }
  };

  return (
    <Modal
      toggleTarget={
        <button
          type="button"
          className="btn btn-secondary ml-auto font-semibold"
          data-testid="schedule-test-call"
          disabled={businessPhones.length === 0}
        >
          Schedule test call
        </button>
      }
      actionFunc={handleScheduledTestCalls}
      cancelText="Cancel"
      actionText="Yes"
    >
      <div>
        <h3>Are you sure you want to schedule test call for all business phones?</h3>
        <p className="mt-4">
          If you click yes, all business phones will be scheduled for a test call and be tested
          within one minute of the call being scheduled. You can see the status of the test call in
          the call rescue monitor tab.
        </p>
      </div>
    </Modal>
  );
};

export default BusinessPhonesScheduleTestCallModal;
